import { GenderType } from '@/utils/genders'
import { AxiosInstance } from 'axios'
import { HorseType } from '@/utils/horseType'
import { Page, Pageable } from '@/types'
import { LocalDate, LocalDateTime } from '@/utils/dates'
import { DocumentType } from '@/utils/documentTypes'
import { HorseStatus } from '@/utils/horseStatus'
import { ProtrusionFormula } from '@/utils/protrusionFormula'
import { TechnicalSaleSubscription } from '@/utils/technicalSaleSubscriptions'
import { TechnicalSaleType } from '@/utils/technicalSaleTypes'
import { DocumentState } from '@/utils/documentStates'
import fileDownload from 'js-file-download'
import { SaleIssue } from '@/utils/SaleIssue'
import { RoleType } from '@/utils/roleType'
import axiosInstance from '../index'
import { AddressUnit, PlaceToVisitDto } from '../placeToVisit'
import { ExternalUserDto } from '../user'
import { HeaderDto } from '../header'

export interface MinimalTechnicalSaleDto {
  id: number
  name: string
  startDate: string
  endDate: string
  externalWritersPedigreeStart: LocalDate
  externalWritersPedigreeEnd: LocalDate
  subscribeStart: LocalDate
  subscribeEnd: LocalDate
  correctionsStart: string
  correctionsEnd: string
}

export interface MyArqanaRegistrationTicketDto {
  id: string
  maxNumberOfRegistrations: number
  numberOfRegistrationsUsed: number
}

export interface MinimalTechnicalSaleWithSubscriptionsDto {
  id: number
  name: string
  startDate: string
  endDate: string
  externalWritersPedigreeStart: LocalDate
  externalWritersPedigreeEnd: LocalDate
  subscribeStart: LocalDate
  subscribeEnd: LocalDate
  subscriptions: TechnicalSaleSubscription[]
  type: TechnicalSaleType
  documentStart: string
  documentEnd: string
  photo: string
  registrationTicket: MyArqanaRegistrationTicketDto
}

export interface RegistrationHorseRequest {
  microchipId?: string
  sireId?: string
  name?: string
  birthday: string
  deathday: string
  birthCountry: string
  motherName: string | undefined
  motherBirthyear: string | undefined
  motherFatherName: string | undefined
  fatherMotherName: string | undefined
  fatherMotherBirthyear: string | undefined
  fatherMotherFatherName: string | undefined
  fatherName: string | undefined
  fatherBirthyear: string | undefined
  fatherFatherName: string | undefined
  robe: string
  breed: string
  gender: GenderType | ''
  type: HorseType | undefined
  status: HorseStatus | undefined
  stallionPart: number | undefined
  stallionPartNumber: number | undefined
  protrusionFormula: ProtrusionFormula | undefined
  protrusionDate: string | undefined
  stallion: number | undefined
  assimile: boolean
  foreignRegime: boolean
  associationContract: boolean
  rentalContract: boolean
}

export interface RegistrationOwnerRequest {
  lotSellerId: number
  part: number
}

export interface MixRegistrationOwnerRequest {
  lotSellerId: number
  internal: boolean
  part: number
}

export interface RegistrationHorseValidationRequest {
  microchipId?: string
  sireId?: string
  name?: string
  birthday: string
  birthCountry: string
  motherName: string | undefined
  motherBirthyear: string | undefined
  motherFatherName: string | undefined
  fatherMotherName: string | undefined
  fatherMotherBirthyear: string | undefined
  fatherMotherFatherName: string | undefined
  fatherName: string | undefined
  fatherBirthyear: string | undefined
  fatherFatherName: string | undefined
  robe: string
  breed: string
  gender: GenderType | ''
  type: HorseType | undefined
  headerId: number
  placeToVisitId: number
  owners: RegistrationOwnerRequest[]
}

export interface UpdateRegistrationHorseRequest {
  microchipId?: string
  sireId?: string
  birthday: string
  birthCountry: string

  robe: string
  breed: string
  gender: GenderType | ''
  status?: HorseStatus
  // stallionPart: number | undefined
  // stallionPartNumber: number | undefined
  protrusionFormula?: ProtrusionFormula
  protrusionDate?: string
  stallion?: number
  // assimile: boolean
  // foreignRegime: boolean
  associationContract: boolean
  rentalContract: boolean

  headerId: number
  placeToVisitId: number
  owners: RegistrationOwnerRequest[]
}

export interface MinimalPersonContact {
  id: number
  name: string
  firstname: string
  lastname: string
  email: string
  phonenumber: string
  address: AddressUnit
  isInternal?: boolean
}

export interface LotOwner {
  lotSeller: MinimalPersonContact
  part: number
}

type RegistrationState = 'WAITING_RESPONSE' | 'VISITING' | 'REFUSED' | 'ACCEPTED' | 'VISITED' | 'COMPLETED'
export interface GetAllMyArqanaHorseRegistrationDto {
  id: number
  lotExist: boolean

  number: number
  letter: string
  // ExternalUser externalUser;

  technicalSale: MinimalTechnicalSaleDto
  technicalSaleState: string
  microchipId: string
  sireId: string
  name: string

  motherName: string
  motherBirthyear: string
  motherFatherName: string
  fatherMotherName: string
  fatherMotherBirthyear: string
  fatherMotherFatherName: string
  fatherName: string
  fatherBirthyear: string
  fatherFatherName: string

  birthday: string
  birthCountry: string

  gender: GenderType
  breed: string
  robe: string
  assimile: boolean
  strangerRegime: boolean
  type: HorseType

  pedigreeAvailable: boolean
  pedigreeUploaded: boolean

  horseStatus?: HorseStatus | undefined
  protrusionFormula?: ProtrusionFormula | undefined
  protrusionDate?: string | undefined
  stallionId?: number | undefined
  stallionName?: string | undefined
  stallionPart?: number | undefined
  stallionPartNumber?: number | undefined

  associationContract: boolean
  rentalContract: boolean

  hasResponse: boolean
  state: RegistrationState

  exposingDay: LocalDate
  createdTime: string
  updatedTime: string

  visibilityOwner: boolean
  visibilityConsigner: boolean
  visibilityVisit: boolean
  lotState: 'DEFAULT' | 'INSCRIPTION' | 'FORFAIT'

  owners: LotOwner[]
  header?: HeaderDto
  placeToVisit: PlaceToVisitDto
  sellerValidatedTime?: string
  sellerUpdateRequest?: boolean

  saleIssueFinal: SaleIssue

  availableMandat: boolean
  signedMandat: boolean
}

export interface RegistrationDocumentDto {
  type: DocumentType
  validation: boolean
  validedTime: LocalDateTime
  createdTime: LocalDateTime
  updatedTime: LocalDateTime
  status: 'ACCEPTED' | 'WAITING' | 'REJECTED'
  internalUpload?: boolean
}

export interface FindByIdMyArqanaHorseRegistrationDto extends GetAllMyArqanaHorseRegistrationDto {
  documents: RegistrationDocumentDto[]
  vetCertificate: boolean
  pedigreeAvailable: boolean
  pedigreeUploaded: boolean
  pedigreeValidated: boolean
  blockingVNC: boolean
  mareFull: boolean
  cribBiter: boolean
  windSucker: boolean
  weaver: boolean
  boxwalker: boolean
  associationContract: boolean
  rentalContract: boolean
  exposingDay: LocalDate
}

export interface GetMyFileMyArqanaPedigreeDto {
  downloadUrl?: string
  lastPedigreeUpload?: string
  pedigreeRejectionComment?: string
  pedigreeChangeRequest?: string
  currentStatus: DocumentState
  requester?: ExternalUserDto
}

export type MyArqanaRegistrationRessourceType = 'PICTURE' | 'VIDEO'
export interface MyArqanaRegistrationRessourceDto {
  id: number

  type: MyArqanaRegistrationRessourceType
  createdTime: LocalDateTime
  downloadUrl: string
  status: 'ACCEPTED' | 'WAITING' | 'REJECTED'
  rejectReason?: string
}

class MyRegistrationApi {
  // eslint-disable-next-line no-useless-constructor, no-empty-function
  public constructor(private axios: AxiosInstance) {}

  public async register(saleId: number, form: RegistrationHorseValidationRequest, token?: string) {
    await this.axios.post(`/sale/${saleId}/my-registration`, { ...form, subscribeTicketId: token })
  }

  public getAll(filter: { states?: ('REFUSED'|'ACCEPTED'|'WAITING'|'NOT_COMPLETED')[], saleId?: number, name?: string, old?: boolean }, pageable: Pageable): Promise<Page<GetAllMyArqanaHorseRegistrationDto>> {
    return this.axios.get('/horse-registration', { params: { ...filter, ...pageable } }).then(it => it.data)
  }

  public getAllWithDocuments(filter: { states?: ('REFUSED'|'ACCEPTED'|'WAITING'|'NOT_COMPLETED')[], saleId?: number, name?: string, types?: HorseType[], exposingDays?: string[], old?: boolean, roles?: RoleType[] }, pageable: Pageable): Promise<Page<FindByIdMyArqanaHorseRegistrationDto>> {
    return this.axios.get('/horse-registration/documents', { params: { ...filter, ...pageable } }).then(it => it.data)
  }

  public findById(id: number) : Promise<FindByIdMyArqanaHorseRegistrationDto> {
    return this.axios.get(`/horse-registration/${id}`).then(it => it.data)
  }

  public getAllResources(id: number) : Promise<MyArqanaRegistrationRessourceDto[]> {
    return this.axios.get(`/registration/${id}/resource`).then(it => it.data)
  }

  public sendDocument(registrationId: number, type: DocumentType, fileOrFormData: File | FormData): Promise<unknown> {
    let formData: FormData

    if (fileOrFormData instanceof FormData) {
      formData = fileOrFormData
    } else {
      formData = new FormData()
      formData.append('file', fileOrFormData)
    }
    return this.axios.post(`/registration/${registrationId}/document/${type}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  public getDocument(registrationId: number, type: DocumentType): Promise<{ downloadUrl: string, name: string }> {
    return this.axios.get(`/registration/${registrationId}/document/${type}/file`).then(d => d.data)
  }

  public getPedigree(registrationId: number): Promise<Array<GetMyFileMyArqanaPedigreeDto>> {
    return this.axios.get(`/registration/${registrationId}/pedigree/my-file`).then(d => d.data)
  }

  public async downloadAllPedigrees(ids: number[]) {
    const response = await this.axios.get('/registration/pedigree', { params: { ids }, responseType: 'blob' })
    fileDownload(response.data, 'pedigrees.pdf')
    return response.headers['pedigree-number']
  }

  public getOriginalPedigree(registrationId: number): Promise<{ downloadUrl: string, originalPedigreeAccepted: boolean }> {
    return this.axios.get(`/registration/${registrationId}/pedigree/original-file`).then(d => d.data)
  }

  public async downloadOriginalPedigreePdf(registrationId: number) {
    const response = await this.axios.get(`/registration/${registrationId}/arqana-pedigree`, { responseType: 'blob' })
    fileDownload(response.data, 'pedigrees.pdf')
  }

  public async acceptOriginalPedigree(registrationId: number, accepted: boolean): Promise<boolean> {
    return (await this.axios.post(`/registration/${registrationId}/pedigree/original-file`, accepted)).data
  }

  public sendPedigree(registrationId: number, pedigreeFile: File, changeRequest: string): Promise<void> {
    const formData = new FormData()
    formData.append('changeRequest', changeRequest)
    formData.append('file', pedigreeFile)
    return this.axios.post(`/registration/${registrationId}/pedigree`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  public sendResource(registrationId: number, photoFile: File, type: MyArqanaRegistrationRessourceType): Promise<MyArqanaRegistrationRessourceDto> {
    const formData = new FormData()
    formData.append('file', photoFile)
    return this.axios.post(`/registration/${registrationId}/${type === 'VIDEO' ? 'video' : 'picture'}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(r => r.data)
  }

  public deleteResource(resourceId: number): Promise<void> {
    return this.axios.delete(`/resource/${resourceId}`)
  }

  public async sendChangeRequest(registrationId: number, changeRequest: string) {
    await this.axios.post(`/registration/${registrationId}/pedigree/change-request`, { text: changeRequest })
  }

  public countByConsigner(): Promise<number> {
    return this.axios.get('/registration/consignment/count').then(d => d.data)
  }

  public getByConsigner(pageable: Pageable): Promise<Page<GetAllMyArqanaHorseRegistrationDto>> {
    return this.axios.get('/registration/consignment', { params: { ...pageable } }).then(d => d.data)
  }

  public consignerAccept(r: GetAllMyArqanaHorseRegistrationDto): Promise<void> {
    return this.axios.post('/registration/consignment', { registrationId: r.id, accepted: true })
  }

  public consignerReject(r: GetAllMyArqanaHorseRegistrationDto): Promise<void> {
    return this.axios.post('/registration/consignment', { registrationId: r.id, accepted: false })
  }

  public async sendVetCertificate(saleId: number, file: File) {
    const formData = new FormData()
    formData.append('saleId', saleId.toString())
    formData.append('file', file)
    return this.axios.post('/sale/vet-certificate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  public async downloadSaleGroupSummary(saleId: number, saleName: string) {
    const response = await this.axios.get(`/sale/${saleId}/summary-file`, { responseType: 'blob' })
    fileDownload(response.data, `Récapitulatif ${saleName}.xlsx`)
  }

  public async updateRegistrationOwners(registrationId: number, ownersP: MixRegistrationOwnerRequest[]) {
    return this.axios.put(`/registration/${registrationId}/owner`, { owners: ownersP })
  }

  public async updateRegistration(id: number, request: UpdateRegistrationHorseRequest) {
    await this.axios.put(`/horse-registration/${id}`, request)
  }
}

export const myRegistrationApi = new MyRegistrationApi(axiosInstance)
